import { render, staticRenderFns } from "./v4_mobile.vue?vue&type=template&id=45523fac&scoped=true&"
import script from "./v4_mobile.vue?vue&type=script&lang=js&"
export * from "./v4_mobile.vue?vue&type=script&lang=js&"
import style0 from "./v4_mobile.vue?vue&type=style&index=0&id=45523fac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45523fac",
  null
  
)

export default component.exports